import * as components from "./index";
import React from "react";
import {
  Product,
  RuntimeConfig,
  SimpleValueMap,
  ConfigProps,
} from "../types/types";
import { VariantCreditOffering } from "../types/cobeTypes";

export type StandardProps = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  experiences: SimpleValueMap;
  experiencesRawString: string;
  configProps?: ConfigProps;
  creditOffers?: VariantCreditOffering[];
};

type StandardComponent = (
  props: StandardProps & { sizes: string },
) => React.ReactNode;

type ComponentMap = { [name: string]: StandardComponent };

export const componentMap: ComponentMap = components;
